class ArticleSlider extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('.article-container-slider');

    if (this.slider) {
      this.initSlider();
    }
  }

  initSlider() {
    this.swiper = new Swiper(this.slider, {
      slidesPerView: 1.5,
      spaceBetween: 8,
      watchOverflow: true,
      breakpoints: {
        576: {
          slidesPerView: 2,
          spaceBetween: 8,
        }
      },
      navigation: {
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev'),
      },
      pagination: {
        el: this.querySelector('.swiper-pagination'),
        clickable: true,
      }
    });
  }
}

customElements.define('article-slider', ArticleSlider); 